//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'BB',
  data() {
    return {
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
      },
      hasScore: false,
      disabled: false,
      descTxt: '',
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5
      self.hasScore = true
      if (result < 2) {
        self.descTxt = '低危'
      } else if (result == 2) {
        self.descTxt = '中低危'
      } else if (result == 3) {
        self.descTxt = '中高危'
      } else {
        self.descTxt = '高危'
      }
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/BB.vue